import { type PopupProps, Popup } from '@CS/components/Popups';
import LocalizedImage from '@CS/components/LocalizedImage';
import type { Quiz } from '@/services/api/types';
import { useTranslation } from '@CS/hooks';
import Button from '@CS/components/Button';
import CSS from './Correct.module.css';
import Images from '@/assets/images';
import { useState } from 'react';
import Content from './content';

type CorrectProps = PopupProps & {
  last?: boolean;
  quiz: Quiz;
};

export const Correct = ({ quiz, last, ...props }: CorrectProps) => {
  const { title, next, complete } = useTranslation(Content);
  const [close, setClose] = useState(false);
  const onClick = () => setClose(true);
  const button = last && complete || next;

  return (
    <Popup
      hideClose
      {...props}
      opacity="0"
      close={close}
      className={CSS.correctContainer}
    >
      <LocalizedImage name="Well Done!" images={Images.Correct} />

      <div className={CSS.correctContent}>
        <h4>{title}</h4>
        <Button text={button} onClick={onClick} />
      </div>
    </Popup>
  );
};
